export default __webpack_public_path__ + "static/media/750x750 hamsterFood.cb5fe0c4.jpg";